import React, { useState } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser';
import { Svg } from '../../1_Atoms/Svg/Svg';
import RangeSlider from './RangeSlider/RangeSlider';
import { convertMinutesToHours } from '../../../utils/helpers';

const getEVBatteryDistance = (startValue, endValue, rangeGainBy10) => {
  // (("to" - "from") / 10) * "Range gain by 10% charge"
  return ((endValue - startValue) / 10) * Number(rangeGainBy10)
}

const getEVBatteryHours = (startValue, endValue, timeChargeBy10) => {
  // (("to" - "from") / 10) * "Time to charge up by 10%"
  return ((endValue - startValue) / 10) * Number(timeChargeBy10)
}

function EVBatteryCalculator({
  formExtraParams
}) {
  const { introductionText, rangeGainBy10, timeChargeBy10, disclaimerText } = formExtraParams;
  const [rangeVal, setRangeVal] = useState({
    startValue: 20,
    endValue: 80,
  });

  const { startValue, endValue } = rangeVal;

  const [resultDistance, setResultDistance] = useState(() => getEVBatteryDistance(startValue, endValue, rangeGainBy10));
  const [resultHours, setResultHours] = useState(() => getEVBatteryHours(startValue, endValue, timeChargeBy10));

  const handleRangeChange = (e) => {
    const { name, value } = e.target;
    const numericVal = Number(value);

    if (name === 'startValue' && numericVal >= endValue) {
      return;
    } else if (name === 'endValue' && numericVal <= startValue) {
      return;
    }

    setRangeVal({ ...rangeVal, [name]: numericVal })

    // Handle results update.
    let newDistance, newHours;

    if (name === 'startValue') {
      newDistance = getEVBatteryDistance(numericVal, endValue, rangeGainBy10)
      newHours = getEVBatteryHours(numericVal, endValue, timeChargeBy10)
    }
    else if (name === 'endValue') {
      newDistance = getEVBatteryDistance(startValue, numericVal, rangeGainBy10)
      newHours = getEVBatteryHours(startValue, numericVal, timeChargeBy10)
    }

    setResultDistance(newDistance)
    setResultHours(newHours)
  }

  const generateHoursCopy = () => {
    const convertedTime = convertMinutesToHours(resultHours);
    return `${convertedTime.hours} Hour${convertedTime.hours > 1 ? 's' : ''} ${convertedTime.minutes} Min`;
  }

  return (
    <div className="mz-ev-battery-calculator">
      <div className="mz-container">
        <div className="mz-full-width mz-ev-battery-calculator__inner">
          {introductionText && (
            <div className="mz-ev-battery-calculator__intro-text">
              {parse(introductionText)}
            </div>
          )}
          <RangeSlider
            startValue={startValue}
            endValue={endValue}
            onChange={handleRangeChange}
          />
          <div className="mz-ev-battery-calculator__results">
            {/* TODO: Add FR copies when it's ready. */}
            <p className="paragraph">Charging from <span className="strong">{startValue}% to {endValue}% battery</span></p>
            <h5>Adds <span className="strong">{resultDistance.toFixed(0)}km</span> range in <span className="strong">{generateHoursCopy()}</span></h5>
          </div>
          {
            disclaimerText && (
              <div className="mz-ev-battery-calculator__disclaimer label text--grey">
                {parse(disclaimerText)}
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

EVBatteryCalculator.propTypes = {
  formExtraParams: PropTypes.object.isRequired
}

EVBatteryCalculator.defaultProps = {
  formExtraParams: {}
}

export default EVBatteryCalculator